
// Should look similar to logic in ECS::Customer::AddressValidator
var AddressValidator = function( rules ) {
    var av = this;
    av.rules = rules;

    av.validate = function( address, rules ) {
        if( ! rules ) rules = av.rules;

        var results = {};
        $.each( Object.keys( rules ), function( i, field ) {
            var rule = rules[ field ];
            var target = av.getRuleTarget( address, field );
            if( ! target ) return;

            var result = av.validateField( rule, address, target.value );
            if( ! result.valid ) results[ target.name ] = result.errMsg;
        } );

        return results;
    };

    av.getRuleTarget = function( address, field ) {
        if( address[ field ] ) {
            return {
                'name' : field,
                'value' : address[ field ],
            };
        }

        var result = false;
        $.each( Object.keys( address ), function( i, addressField ) {
            if( addressField.match( field + "$" ) ) {
                result = {
                    'name'  : addressField,
                    'value' : address[ addressField ],
                };
            }
        } );
        return result;
    };

    av.validateField = function( rule, address, target ) {
        // deep copy the rule to avoid changing the original
        rule = JSON.parse( JSON.stringify( rule ) );

        if( rule.cond ) {
            var conds = rule.cond;

            for( var i = 0; i < conds.length; i += 2 ) {
                var cond   = conds[ i ];
                var action = conds[ i + 1 ];

                var condValid = av.validate( address, cond );

                // if there were no errors, this passed
                if( Object.keys( condValid ).length == 0 ) {
                    $.extend( rule, action );
                    break;
                }
            }
        }

        if( rule.filter
            && rule.filter == "upper"
            ) {
            target = target.toUpperCase();
        }

        var result = {
            'valid'  : true,
            'errMsg' : "",
        };
        $.each( Object.keys( rule ), function( i, type ) {
            var value = rule[ type ];
            var targ = target || "";
            if( type == "min"
                && targ.length < value
                ) {
                result = {
                    'valid'  : false,
                    'errMsg' : "Requires " + value + " character(s)",
                };
            }
            else if( type == "max"
                && targ.length > value
                ) {
                result = {
                    'valid'  : false,
                    'errMsg' : "Maximum " + value + " characters",
                };
            }
            else if( type == "pattern"
                && ! targ.match( value )
                ) {
                result = {
                    'valid'  : false,
                    'errMsg' : "Invalid format",
                };
            }
            else if( type == "is" ) {
                if( value instanceof Array
                    && value.indexOf( targ ) == -1
                    ) {
                    result = {
                        'valid'  : false,
                        'errMsg' : "Required",
                    };
                }
                else if( typeof value == "string"
                    && targ != value
                    ) {
                    result = {
                        'valid'  : false,
                        'errMsg' : "Required",
                    };
                }
            }
            else if( type == "display" ) {
                result.hide = ! value;
            }
        } );

        return result;
    };

    // determine whether or not to display each address field
    av.getFieldDisplay = function( address ) {
        var results = {};

        $.each( Object.keys( rules ), function( i, field ) {
            var rule = rules[ field ];
            var target = av.getRuleTarget( address, field );
            if( ! target ) return;

            var result = av.validateField( rule, address, target.value );
            results[ target.name ] = result.hide ? false : true;
        } );

        return results;
    };
};

